import Navbar from "@/components/feature/Navbar";
import HeroSection from "@/components/feature/HeroSection";
import CategorySection from "@/components/feature/CategorySection";
import ValueProposition from "@/components/feature/ValueProposition";
import FeatureComparison from "@/components/feature/FeatureComparison";
import ArticleSection from "@/components/feature/ArticleSection";
import CTASection from "@/components/feature/CTASection";
import Footer from "@/components/feature/Footer";
import { getWebSiteJsonLd } from "@/utils/seo";

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(getWebSiteJsonLd()) }}
      />
      <Navbar />
      <main>
        {/* Hero */}
        <HeroSection />

        {/* Category Navigation */}
        <CategorySection />

        {/* Value Proposition */}
        <ValueProposition />

        {/* Feature Comparison Table */}
        <FeatureComparison />

        {/* SEO Articles */}
        <ArticleSection />

        {/* CTA + Newsletter */}
        <CTASection />
      </main>
      <Footer />
    </>
  );
}